/**
 * web/src/lib/cn.ts
 * Tailwind-aware class merger. clsx() handles falsy + array inputs;
 * twMerge() resolves conflicting Tailwind utility classes (e.g., 'px-2 px-4' → 'px-4').
 * Used by every component built on cva variants (Button, Badge, Dot, etc.).
 */
import { clsx, type ClassValue } from 'clsx';
import { twMerge } from 'tailwind-merge';

/**
 * Merges class strings with Tailwind conflict resolution.
 * @param inputs class values, including booleans/arrays/objects
 * @returns a single space-separated class string
 */
export function cn(...inputs: ClassValue[]): string {
  return twMerge(clsx(inputs));
}
